<template>
  <div class="form-con">
    <a-form  @keydown.enter="handleSubmit" @submit="handleSubmit" :form="form">
      <a-form-item>
        <a-input class="input" :placeholder="$t('login.account')"
          v-decorator="['username',{rules: [{ required: true, message: $t('login.accountTip') }]}]">
          <a-icon slot="prefix" type='user' style="color:rgba(0,0,0,.25)" />
        </a-input>
      </a-form-item>
      <a-form-item>
        <a-input v-decorator="['password',{rules: [{ required: true, message: $t('login.passwordTip') }]}]"
          type='password' :placeholder="$t('login.password')">
          <a-icon slot="prefix" type='lock' style="color:rgba(0,0,0,.25)" />
        </a-input>
      </a-form-item>
      <a-form-item v-if="needVerifyCode" >
        <a-input class="verify" autocomplete="off" :placeholder="$t('login.verifyCode')"
          v-decorator="['verifyCode',{rules: [{ required: true, message: $t('login.verifyCodeTip')}, {len: 4, message: $t('login.verifyCodeLengthTip')}]}]">
          <zx-icon slot="prefix" type='icon-yanzhengma' style="color:rgba(0,0,0,.25)"></zx-icon>
          <!-- <a-icon slot="prefix" type='user' style="color:rgba(0,0,0,.25)" /> -->
        </a-input>
        <img class="img" :src="verifyCodeUrl" @click="refreshVerifyCode" :alt="$t('login.verifyCode')">
      </a-form-item>
      <a-checkbox :checked="checked" @change="rememberAccount" >{{$t('login.rememberAccount')}}</a-checkbox>
      <a-button class="submit-btn" type='primary' htmlType='submit' :disabled="hasErrors(form.getFieldsError())">
          {{$t('login.login')}}
      </a-button>
    </a-form>
  </div>
</template>
<script>
import Vue from 'vue'
import config from '../config'
import {loginSuccess} from '../model/loginSuccess'
function hasErrors(fieldsError) {
  return Object.keys(fieldsError).some(field => fieldsError[field])
}
export default {
  data () {
    return {
      form: this.$form.createForm(this),
      hasErrors,
      needVerifyCode: false,
      verifyCodeUrl: '',
      checked: false
    }
  },
  // computed: {
  //   hasErrors () {
  //     return Object.keys(form.getFieldsError()).some(field => form.getFieldsError()[field])
  //   }
  // },
  created () {
    this.$store.dispatch('logout', "")
    this.needVerify()
    // this.getStorgeUsername()
  },
  mounted () {
    this.getStorgeUsername()
  },
  methods: {
    // 记住账号
    rememberAccount (ev) {
      this.checked = ev.target.checked
      // console.log(this.checked)
    },
    // 获取用户名
    getStorgeUsername () {
      let username = localStorage.getItem('userName')
      if (username) {
        // console.log(username)
        // console.log(this.form)
        this.form.setFieldsValue({
          username
        })
        // this.form.username = username
        this.checked = true
      }
    },
    needVerify() {
      this.$http.get(config.api.login_need_verify).then((res) => {
        // console.log(res)
        if (res && res.code === 0) {
          // 不需要验证码
          this.needVerifyCode = false
        } else {
          this.needVerifyCode = true
          // 获取验证码图片
          this.getVerifyCode()
        }
      })
    },
    getVerifyCode () {
      let random = Math.floor(Math.random() * 100)
      this.verifyCodeUrl = `${config.api.verify_image_url}/api/commons/v1.0/verifyCode/image?key=${random}&isPwd=true`
    },
    refreshVerifyCode () {
      this.getVerifyCode()
    },
    hasValidError (attr) {
      const {
        getFieldError,
        isFieldTouched
      } = this.form
      return isFieldTouched(attr) && getFieldError(attr)
    },
    handleSubmit(e) {
      e.preventDefault()
      this.form.validateFields((err, values) => {
        if (!err) {
          // console.log('Received values of form: ', values)
          if (this.checked) {
            // 将账号写入storge
            // console.log(this.ls)
            localStorage.setItem('userName', values.username)
          } else {
            localStorage.removeItem('userName')
          }
          this.$http.post(config.api.auth_url, values).then((response) => {
            this.loginResponse(response)
          })
        }
      })
    },
    loginResponse(response) {
      // console.log(response)
      if (response.code !== 0) {
        // debugger
        this.form.resetFields([
          'password',
          'verifyCode'
        ])
        this.needVerify()
        // this.refreshVerifyCode()
        // this.errInfo = response.desc
        this.$emit('errInfo', response.desc)
        // this.needVerifyCode = true
        // this.$notification.warning({
        //   message: '登陆失败',
        //   description: '密码错误或者账号不存在'
        // })
      } else {
        let result = response.result
        // console.log(result)

        this.$notification.success({
          message: this.$t('login.loginSuccess'),
          description: result.username + ', ' + this.$t('login.welcome')
        })
        loginSuccess(result)
        // let userid = result.userid
        // let userImage = result.userLogo
        // let systemImage = result.systemLogo
        // let systemName = result.systemName
        // let token = result.token
        // let orgName = result.orgName
        // // console.log(expiration)
        // let roles = result.roles
        // let level = result.level
        // this.$store.dispatch('setToken', {
        //   token: token,
        // })
        // this.$store.dispatch('setLevel', level)

        // this.$store.dispatch('setUser', {
        //   name: result.username,
        //   id: userid,
        //   roles: roles,
        //   userImage: userImage
        // })
        // this.$store.dispatch('setOrg', {
        //   level: level,
        //   systemImage: systemImage,
        //   systemName: systemName,
        //   orgName
        // })
        // if (roles && (roles === 'SuperAdmin' || roles === 'Integrator')) {
        //     //key暂时写死,后面应从数据库获取
        //   Vue.ls.set('activeMenu', 1);
        //   this.$router.push('/overview')
        // }  else{
        //   Vue.ls.set('activeMenu', 1);
        //   this.$router.push('/home')
        // }
      }
    }  
  }
}
</script>
<style lang="less" scoped>
.form-con {
  width: 300px;
  .verify {
    width: 75%;
    margin-right: 15px; 
  }
  .img {
    width: 20%;
    cursor: pointer;
  }
  .span {
    font-size: .8rm;
    line-height: .8;
  }
  .err-help {
    color: red;
  }
  .submit-btn {
    width: 100%;
    margin-top: 10px;
  }
}
</style>
